export default {
  SET_SENT_DATA(state, sentData) {
    state.sent = sentData;
  },
  SET_SENT_RECORDS(state, totalSent) {
    state.totalSent = totalSent;
  },
  SET_CURRENT_PAGE(state, data) {
    state.sent.currentPage = data;
  },
};
